import { render, staticRenderFns } from "./OtherFilter.vue?vue&type=template&id=0a89d9e3&scoped=true"
import script from "./OtherFilter.vue?vue&type=script&lang=js"
export * from "./OtherFilter.vue?vue&type=script&lang=js"
import style0 from "./OtherFilter.vue?vue&type=style&index=0&id=0a89d9e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a89d9e3",
  null
  
)

export default component.exports